var map = {
	"./IMG-20241019-WA0033.jpg": 7417,
	"./IMG-20250420-WA0002.jpg": 9907,
	"./IMG_20240815_130931.jpg": 4579,
	"./IMG_20241018_093731.jpg": 8807,
	"./leafs.jpg": 9960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2455;